<template>
  <woot-modal :show.sync="show" :on-close="onCancel">
    <div class="h-auto overflow-auto flex flex-col">
      <woot-modal-header
        :header-title="$t('BLOCK_CONTACT.TITLE')"
        :header-content="$t('BLOCK_CONTACT.DESC')"
      />
      <form
        @submit.prevent="onBlock"
        class="w-full">
        <label class="input-wrap">
          {{ $t('BLOCK_CONTACT.FORM.REASON.LABEL') }}
        </label>
        <textarea
          v-model="blockReason"
          rows="4"
          class="w-full resize-none"
          :class="{ error: showError }"
          :placeholder="$t('BLOCK_CONTACT.FORM.REASON.PLACEHOLDER')"
        />
        <p v-if="showError" class="error message">
          {{ $t('BLOCK_CONTACT.FORM.REASON.ERROR') }}
        </p>
        <div class="modal-footer">
          <woot-button variant="clear" @click="onCancel">
            {{ $t('BLOCK_CONTACT.FORM.CANCEL') }}
          </woot-button>
          <woot-button
            variant="smooth"
            color-scheme="alert"
            :disabled="!blockReason.trim() || uiFlags.isBlocking"
            :is-loading="uiFlags.isBlocking"
            @click="onBlock"
          >
            {{ $t('BLOCK_CONTACT.FORM.SUBMIT') }}
          </woot-button>
        </div>
      </form>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  props: {
    contact: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      blockReason: '',
      showError: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
  },
  methods: {
    async onBlock() {
      if (!this.blockReason.trim()) {
        this.showError = true;
        return;
      }
      try {
        await this.$store.dispatch('contacts/block', {
          id: this.contact.id,
          blockReason: this.blockReason.trim(),
        });
        this.showAlert(this.$t('BLOCK_CONTACT.FORM.SUCCESS_MESSAGE'));
        this.$emit('blocked');
      } catch (error) {
        this.showAlert(
          error.message || this.$t('BLOCK_CONTACT.FORM.ERROR_MESSAGE')
        );
      }
    },
    onCancel() {
      this.blockReason = '';
      this.showError = false;
      this.$emit('cancel');
    },
  },
};
</script>
